'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseModal } from 'components';
import Disable2FaForm from './components/Disable2FaForm';

import { IDisableGaModalProps } from './DisableGaModal.types';

const DisableGaModal = ({ open, onClose, onFinish }: IDisableGaModalProps) => {
  const { t } = useTranslation();

  return (
    <BaseModal title={t('modal.twoFADisable.title')} open={open} width={450} onClose={onClose}>
      <Disable2FaForm onFinish={onFinish} onError={onClose} />
    </BaseModal>
  );
};

export default DisableGaModal;
